import { render, staticRenderFns } from "./View_RUM.vue?vue&type=template&id=837716e4&scoped=true"
import script from "./View_RUM.vue?vue&type=script&lang=js"
export * from "./View_RUM.vue?vue&type=script&lang=js"
import style0 from "./View_RUM.vue?vue&type=style&index=0&id=837716e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837716e4",
  null
  
)

export default component.exports